export const reduceStepsForValidation = (stepList) => stepList.map((step) => ({
  path: step.step.path,
  required_fields: step.form ? getFormFields(step.form) : null,
}));

const getFormFields = (formRows) => {
  const fields = [];
  formRows.map((row) =>
    row.fields.forEach((field) => {
      if (field.type !== "submit" && field.name) {
        fields.push(field.name);
      }
    }));
  return fields;
};

export const getStepsToComplete = (completedSteps, steps) => {
  const stepsToComplete = [];
  const values = Object.values(steps);
  values.forEach((step) => {
    if (!completedSteps.includes(step.path)) {
      stepsToComplete.push(step.path);
    }
  });
  return stepsToComplete;
};

export const getNextRequiredStep = (stepsToComplete) => stepsToComplete[0];
